import React from "react";
import { Link } from "react-router-dom";
import { Sparkles, Truck, ShieldCheck, RotateCcw } from "lucide-react";

export const Footer = () => (
  <footer className="mt-24 border-t-2 border-ink bg-ink text-cream" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
        {[
          { icon: Truck, title: "Fast Free Shipping", desc: "On all orders over $50" },
          { icon: ShieldCheck, title: "Secure Checkout", desc: "256-bit encrypted payments" },
          { icon: RotateCcw, title: "30-Day Returns", desc: "Not happy? Send it back" },
        ].map((f, i) => (
          <div key={i} className="flex items-center gap-4 bg-white/5 rounded-2xl p-5 border border-white/10">
            <f.icon className="w-8 h-8 text-brand-yellow shrink-0" />
            <div>
              <p className="font-bold font-heading">{f.title}</p>
              <p className="text-sm text-white/60">{f.desc}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="flex flex-col md:flex-row items-center justify-between gap-6 pt-8 border-t border-white/10">
        <Link to="/" className="flex items-center gap-2">
          <div className="w-9 h-9 bg-brand rounded-lg flex items-center justify-center">
            <Sparkles className="w-5 h-5 text-white" />
          </div>
          <span className="text-xl font-black font-heading">Snagly</span>
        </Link>
        <div className="flex gap-6 text-sm font-medium text-white/70">
          <Link to="/shop" className="hover:text-brand-yellow">Shop</Link>
          <Link to="/orders" className="hover:text-brand-yellow">My Orders</Link>
          <Link to="/login" className="hover:text-brand-yellow">Account</Link>
        </div>
        <p className="text-sm text-white/50">© 2026 Snagly. Snag the good stuff.</p>
      </div>
    </div>
  </footer>
);
